// source: dashboard/dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.dashboard.AddWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.CreateDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.DASHBOARD_CONTEXT', null, global);
goog.exportSymbol('proto.dashboard.Dashboard', null, global);
goog.exportSymbol('proto.dashboard.DashboardPurpose', null, global);
goog.exportSymbol('proto.dashboard.DeleteDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.DeleteWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.Filter', null, global);
goog.exportSymbol('proto.dashboard.Filters', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardFilterValuesRequest', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardFilterValuesResponse', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardLayoutRequest', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardLayoutResponse', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardLiveCountsRequest', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardLiveCountsResponse', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.GetReportingChildAccountsResponse', null, global);
goog.exportSymbol('proto.dashboard.GetVendorHealthVendorsRequest', null, global);
goog.exportSymbol('proto.dashboard.GetVendorHealthVendorsResponse', null, global);
goog.exportSymbol('proto.dashboard.GetWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.ListDashboardsRequest', null, global);
goog.exportSymbol('proto.dashboard.ListDashboardsResponse', null, global);
goog.exportSymbol('proto.dashboard.LiveChartCounts', null, global);
goog.exportSymbol('proto.dashboard.MoveWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.ReportingChildAccount', null, global);
goog.exportSymbol('proto.dashboard.SaveDashboardLayoutRequest', null, global);
goog.exportSymbol('proto.dashboard.UpdateDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.UpdateWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.VendorHealthVendor', null, global);
goog.exportSymbol('proto.dashboard.Widget', null, global);
goog.exportSymbol('proto.dashboard.WidgetDataSource', null, global);
goog.exportSymbol('proto.dashboard.WidgetType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.CreateDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.CreateDashboardRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.CreateDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.CreateDashboardRequest.displayName = 'proto.dashboard.CreateDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.UpdateDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.UpdateDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.UpdateDashboardRequest.displayName = 'proto.dashboard.UpdateDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.DeleteDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.DeleteDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.DeleteDashboardRequest.displayName = 'proto.dashboard.DeleteDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.AddWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.AddWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.AddWidgetRequest.displayName = 'proto.dashboard.AddWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.DeleteWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.DeleteWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.DeleteWidgetRequest.displayName = 'proto.dashboard.DeleteWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.UpdateWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.UpdateWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.UpdateWidgetRequest.displayName = 'proto.dashboard.UpdateWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.MoveWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.MoveWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.MoveWidgetRequest.displayName = 'proto.dashboard.MoveWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetWidgetRequest.displayName = 'proto.dashboard.GetWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.ListDashboardsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.ListDashboardsRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.ListDashboardsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.ListDashboardsRequest.displayName = 'proto.dashboard.ListDashboardsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.ListDashboardsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.ListDashboardsResponse.repeatedFields_, null);
};
goog.inherits(proto.dashboard.ListDashboardsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.ListDashboardsResponse.displayName = 'proto.dashboard.ListDashboardsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardRequest.displayName = 'proto.dashboard.GetDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Filters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Filters.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Filters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Filters.displayName = 'proto.dashboard.Filters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Filter.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Filter.displayName = 'proto.dashboard.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Dashboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Dashboard.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Dashboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Dashboard.displayName = 'proto.dashboard.Dashboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Widget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.Widget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Widget.displayName = 'proto.dashboard.Widget';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardFilterValuesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.GetDashboardFilterValuesRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.GetDashboardFilterValuesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardFilterValuesRequest.displayName = 'proto.dashboard.GetDashboardFilterValuesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardFilterValuesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.GetDashboardFilterValuesResponse.repeatedFields_, null);
};
goog.inherits(proto.dashboard.GetDashboardFilterValuesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardFilterValuesResponse.displayName = 'proto.dashboard.GetDashboardFilterValuesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.ReportingChildAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.ReportingChildAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.ReportingChildAccount.displayName = 'proto.dashboard.ReportingChildAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetReportingChildAccountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.GetReportingChildAccountsResponse.repeatedFields_, null);
};
goog.inherits(proto.dashboard.GetReportingChildAccountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetReportingChildAccountsResponse.displayName = 'proto.dashboard.GetReportingChildAccountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.LiveChartCounts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.LiveChartCounts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.LiveChartCounts.displayName = 'proto.dashboard.LiveChartCounts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardLiveCountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.GetDashboardLiveCountsRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.GetDashboardLiveCountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardLiveCountsRequest.displayName = 'proto.dashboard.GetDashboardLiveCountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardLiveCountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetDashboardLiveCountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardLiveCountsResponse.displayName = 'proto.dashboard.GetDashboardLiveCountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetVendorHealthVendorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetVendorHealthVendorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetVendorHealthVendorsRequest.displayName = 'proto.dashboard.GetVendorHealthVendorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.VendorHealthVendor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.VendorHealthVendor.repeatedFields_, null);
};
goog.inherits(proto.dashboard.VendorHealthVendor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.VendorHealthVendor.displayName = 'proto.dashboard.VendorHealthVendor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetVendorHealthVendorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.GetVendorHealthVendorsResponse.repeatedFields_, null);
};
goog.inherits(proto.dashboard.GetVendorHealthVendorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetVendorHealthVendorsResponse.displayName = 'proto.dashboard.GetVendorHealthVendorsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.SaveDashboardLayoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.SaveDashboardLayoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.SaveDashboardLayoutRequest.displayName = 'proto.dashboard.SaveDashboardLayoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardLayoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetDashboardLayoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardLayoutRequest.displayName = 'proto.dashboard.GetDashboardLayoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardLayoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetDashboardLayoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardLayoutResponse.displayName = 'proto.dashboard.GetDashboardLayoutResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.CreateDashboardRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.CreateDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.CreateDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.CreateDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.CreateDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    width: jspb.Message.getFieldWithDefault(msg, 3, 0),
    height: jspb.Message.getFieldWithDefault(msg, 4, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 5, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 6, ""),
    widgetsList: jspb.Message.toObjectList(msg.getWidgetsList(),
    proto.dashboard.Widget.toObject, includeInstance),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.CreateDashboardRequest}
 */
proto.dashboard.CreateDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.CreateDashboardRequest;
  return proto.dashboard.CreateDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.CreateDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.CreateDashboardRequest}
 */
proto.dashboard.CreateDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 7:
      var value = new proto.dashboard.Widget;
      reader.readMessage(value,proto.dashboard.Widget.deserializeBinaryFromReader);
      msg.addWidgets(value);
      break;
    case 8:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.CreateDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.CreateDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.CreateDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.CreateDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWidgetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.dashboard.Widget.serializeBinaryToWriter
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 width = 3;
 * @return {number}
 */
proto.dashboard.CreateDashboardRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height = 4;
 * @return {number}
 */
proto.dashboard.CreateDashboardRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional DashboardPurpose purpose = 5;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.CreateDashboardRequest.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string configuration = 6;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Widget widgets = 7;
 * @return {!Array<!proto.dashboard.Widget>}
 */
proto.dashboard.CreateDashboardRequest.prototype.getWidgetsList = function() {
  return /** @type{!Array<!proto.dashboard.Widget>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Widget, 7));
};


/**
 * @param {!Array<!proto.dashboard.Widget>} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
*/
proto.dashboard.CreateDashboardRequest.prototype.setWidgetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.dashboard.Widget=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.CreateDashboardRequest.prototype.addWidgets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.dashboard.Widget, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.clearWidgetsList = function() {
  return this.setWidgetsList([]);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 8;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.CreateDashboardRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.UpdateDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.UpdateDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.UpdateDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    width: jspb.Message.getFieldWithDefault(msg, 4, 0),
    height: jspb.Message.getFieldWithDefault(msg, 5, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 6, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 7, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.UpdateDashboardRequest}
 */
proto.dashboard.UpdateDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.UpdateDashboardRequest;
  return proto.dashboard.UpdateDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.UpdateDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.UpdateDashboardRequest}
 */
proto.dashboard.UpdateDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 6:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 8:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.UpdateDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.UpdateDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.UpdateDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 width = 4;
 * @return {number}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 height = 5;
 * @return {number}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional DashboardPurpose purpose = 6;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string configuration = 7;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 8;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.DeleteDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.DeleteDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.DeleteDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.DeleteDashboardRequest}
 */
proto.dashboard.DeleteDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.DeleteDashboardRequest;
  return proto.dashboard.DeleteDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.DeleteDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.DeleteDashboardRequest}
 */
proto.dashboard.DeleteDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.DeleteDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.DeleteDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.DeleteDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.DeleteDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.DeleteDashboardRequest} returns this
 */
proto.dashboard.DeleteDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 2;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.DeleteDashboardRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.DeleteDashboardRequest} returns this
 */
proto.dashboard.DeleteDashboardRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.AddWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.AddWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.AddWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.AddWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    position: jspb.Message.getFieldWithDefault(msg, 5, 0),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    type: jspb.Message.getFieldWithDefault(msg, 8, 0),
    width: jspb.Message.getFieldWithDefault(msg, 9, 0),
    height: jspb.Message.getFieldWithDefault(msg, 10, 0),
    data: jspb.Message.getFieldWithDefault(msg, 11, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 12, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 13, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 14, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.AddWidgetRequest}
 */
proto.dashboard.AddWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.AddWidgetRequest;
  return proto.dashboard.AddWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.AddWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.AddWidgetRequest}
 */
proto.dashboard.AddWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 13:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    case 15:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 17:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.AddWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.AddWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.AddWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.AddWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
};


/**
 * optional string dashboard_id = 1;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDashboardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDashboardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 position = 5;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional WidgetType type = 8;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.AddWidgetRequest.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int32 width = 9;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 height = 10;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string data = 11;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string configuration = 12;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional WidgetDataSource data_source = 13;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.AddWidgetRequest.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string data_generation_rule = 14;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Filters filters = 15;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.AddWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 15));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
*/
proto.dashboard.AddWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.AddWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string audit_id = 16;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 17;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.AddWidgetRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.DeleteWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.DeleteWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.DeleteWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.DeleteWidgetRequest}
 */
proto.dashboard.DeleteWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.DeleteWidgetRequest;
  return proto.dashboard.DeleteWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.DeleteWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.DeleteWidgetRequest}
 */
proto.dashboard.DeleteWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    case 2:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.DeleteWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.DeleteWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.DeleteWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.DeleteWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.DeleteWidgetRequest} returns this
 */
proto.dashboard.DeleteWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 2;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.DeleteWidgetRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.DeleteWidgetRequest} returns this
 */
proto.dashboard.DeleteWidgetRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.UpdateWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.UpdateWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.UpdateWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    position: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    width: jspb.Message.getFieldWithDefault(msg, 6, 0),
    height: jspb.Message.getFieldWithDefault(msg, 7, 0),
    data: jspb.Message.getFieldWithDefault(msg, 8, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 10, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 11, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.UpdateWidgetRequest}
 */
proto.dashboard.UpdateWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.UpdateWidgetRequest;
  return proto.dashboard.UpdateWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.UpdateWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.UpdateWidgetRequest}
 */
proto.dashboard.UpdateWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 10:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    case 12:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 14:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.UpdateWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.UpdateWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.UpdateWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 position = 4;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional WidgetType type = 5;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 width = 6;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 height = 7;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string data = 8;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string configuration = 9;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional WidgetDataSource data_source = 10;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string data_generation_rule = 11;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Filters filters = 12;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 12));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
*/
proto.dashboard.UpdateWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.UpdateWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string audit_id = 13;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 14;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.MoveWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.MoveWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.MoveWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.MoveWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newPosition: jspb.Message.getFieldWithDefault(msg, 2, 0),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.MoveWidgetRequest}
 */
proto.dashboard.MoveWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.MoveWidgetRequest;
  return proto.dashboard.MoveWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.MoveWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.MoveWidgetRequest}
 */
proto.dashboard.MoveWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewPosition(value);
      break;
    case 3:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.MoveWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.MoveWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.MoveWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.MoveWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPosition();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.MoveWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.MoveWidgetRequest} returns this
 */
proto.dashboard.MoveWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 new_position = 2;
 * @return {number}
 */
proto.dashboard.MoveWidgetRequest.prototype.getNewPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.MoveWidgetRequest} returns this
 */
proto.dashboard.MoveWidgetRequest.prototype.setNewPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 3;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.MoveWidgetRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.MoveWidgetRequest} returns this
 */
proto.dashboard.MoveWidgetRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    widgetName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dashboardName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    auditId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetWidgetRequest}
 */
proto.dashboard.GetWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetWidgetRequest;
  return proto.dashboard.GetWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetWidgetRequest}
 */
proto.dashboard.GetWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 7:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWidgetName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string widget_name = 2;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getWidgetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setWidgetName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dashboard_name = 3;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
*/
proto.dashboard.GetWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool include_data = 5;
 * @return {boolean}
 */
proto.dashboard.GetWidgetRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string audit_id = 6;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 7;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.GetWidgetRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.ListDashboardsRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.ListDashboardsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.ListDashboardsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.ListDashboardsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    namesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.ListDashboardsRequest}
 */
proto.dashboard.ListDashboardsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.ListDashboardsRequest;
  return proto.dashboard.ListDashboardsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.ListDashboardsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.ListDashboardsRequest}
 */
proto.dashboard.ListDashboardsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addNames(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 6:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.ListDashboardsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.ListDashboardsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.ListDashboardsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.dashboard.ListDashboardsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * repeated string names = 2;
 * @return {!Array<string>}
 */
proto.dashboard.ListDashboardsRequest.prototype.getNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setNamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.addNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearNamesList = function() {
  return this.setNamesList([]);
};


/**
 * optional bool include_data = 3;
 * @return {boolean}
 */
proto.dashboard.ListDashboardsRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.ListDashboardsRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
*/
proto.dashboard.ListDashboardsRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.ListDashboardsRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.dashboard.ListDashboardsRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 6;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.ListDashboardsRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.ListDashboardsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.ListDashboardsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.ListDashboardsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.ListDashboardsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardsList: jspb.Message.toObjectList(msg.getDashboardsList(),
    proto.dashboard.Dashboard.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.ListDashboardsResponse}
 */
proto.dashboard.ListDashboardsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.ListDashboardsResponse;
  return proto.dashboard.ListDashboardsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.ListDashboardsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.ListDashboardsResponse}
 */
proto.dashboard.ListDashboardsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.Dashboard;
      reader.readMessage(value,proto.dashboard.Dashboard.deserializeBinaryFromReader);
      msg.addDashboards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.ListDashboardsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.ListDashboardsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.ListDashboardsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.dashboard.Dashboard.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Dashboard dashboards = 1;
 * @return {!Array<!proto.dashboard.Dashboard>}
 */
proto.dashboard.ListDashboardsResponse.prototype.getDashboardsList = function() {
  return /** @type{!Array<!proto.dashboard.Dashboard>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Dashboard, 1));
};


/**
 * @param {!Array<!proto.dashboard.Dashboard>} value
 * @return {!proto.dashboard.ListDashboardsResponse} returns this
*/
proto.dashboard.ListDashboardsResponse.prototype.setDashboardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dashboard.Dashboard=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.ListDashboardsResponse.prototype.addDashboards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dashboard.Dashboard, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsResponse} returns this
 */
proto.dashboard.ListDashboardsResponse.prototype.clearDashboardsList = function() {
  return this.setDashboardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardRequest}
 */
proto.dashboard.GetDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardRequest;
  return proto.dashboard.GetDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardRequest}
 */
proto.dashboard.GetDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 6:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include_data = 3;
 * @return {boolean}
 */
proto.dashboard.GetDashboardRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetDashboardRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
*/
proto.dashboard.GetDashboardRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetDashboardRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 6;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.GetDashboardRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Filters.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Filters.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Filters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Filters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filters.toObject = function(includeInstance, msg) {
  var f, obj = {
    starttime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.dashboard.Filter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Filters}
 */
proto.dashboard.Filters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Filters;
  return proto.dashboard.Filters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Filters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Filters}
 */
proto.dashboard.Filters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 3:
      var value = new proto.dashboard.Filter;
      reader.readMessage(value,proto.dashboard.Filter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Filters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Filters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Filters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.dashboard.Filter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 startTime = 1;
 * @return {number}
 */
proto.dashboard.Filters.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.setStarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 endTime = 2;
 * @return {number}
 */
proto.dashboard.Filters.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Filter filters = 3;
 * @return {!Array<!proto.dashboard.Filter>}
 */
proto.dashboard.Filters.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.dashboard.Filter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Filter, 3));
};


/**
 * @param {!Array<!proto.dashboard.Filter>} value
 * @return {!proto.dashboard.Filters} returns this
*/
proto.dashboard.Filters.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.dashboard.Filter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filters.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dashboard.Filter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Filter.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Filter;
  return proto.dashboard.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.dashboard.Filter.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string values = 2;
 * @return {!Array<string>}
 */
proto.dashboard.Filter.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Dashboard.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Dashboard.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Dashboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Dashboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Dashboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    widgetsList: jspb.Message.toObjectList(msg.getWidgetsList(),
    proto.dashboard.Widget.toObject, includeInstance),
    width: jspb.Message.getFieldWithDefault(msg, 9, 0),
    height: jspb.Message.getFieldWithDefault(msg, 10, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 11, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.Dashboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Dashboard;
  return proto.dashboard.Dashboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Dashboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.Dashboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = new proto.dashboard.Widget;
      reader.readMessage(value,proto.dashboard.Widget.deserializeBinaryFromReader);
      msg.addWidgets(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 11:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Dashboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Dashboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Dashboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Dashboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getWidgetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.dashboard.Widget.serializeBinaryToWriter
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Dashboard.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Dashboard.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Dashboard.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Dashboard.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string created_by = 4;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Widget widgets = 8;
 * @return {!Array<!proto.dashboard.Widget>}
 */
proto.dashboard.Dashboard.prototype.getWidgetsList = function() {
  return /** @type{!Array<!proto.dashboard.Widget>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Widget, 8));
};


/**
 * @param {!Array<!proto.dashboard.Widget>} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setWidgetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.dashboard.Widget=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Dashboard.prototype.addWidgets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.dashboard.Widget, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearWidgetsList = function() {
  return this.setWidgetsList([]);
};


/**
 * optional int32 width = 9;
 * @return {number}
 */
proto.dashboard.Dashboard.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 height = 10;
 * @return {number}
 */
proto.dashboard.Dashboard.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional DashboardPurpose purpose = 11;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.Dashboard.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string configuration = 12;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Widget.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Widget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Widget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Widget.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    position: jspb.Message.getFieldWithDefault(msg, 8, 0),
    type: jspb.Message.getFieldWithDefault(msg, 9, 0),
    width: jspb.Message.getFieldWithDefault(msg, 10, 0),
    height: jspb.Message.getFieldWithDefault(msg, 11, 0),
    data: jspb.Message.getFieldWithDefault(msg, 12, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 13, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 14, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 15, ""),
    chartName: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Widget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Widget;
  return proto.dashboard.Widget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Widget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Widget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 9:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 14:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setChartName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Widget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Widget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Widget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Widget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getChartName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Widget.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Widget} returns this
*/
proto.dashboard.Widget.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Widget.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Widget.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Widget} returns this
*/
proto.dashboard.Widget.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Widget.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string created_by = 4;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 position = 8;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional WidgetType type = 9;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.Widget.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int32 width = 10;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 height = 11;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string data = 12;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string configuration = 13;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional WidgetDataSource data_source = 14;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.Widget.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string data_generation_rule = 15;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string chart_name = 16;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getChartName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setChartName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.GetDashboardFilterValuesRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardFilterValuesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardFilterValuesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardFilterValuesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardContext: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dashboardName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dimension: jspb.Message.getFieldWithDefault(msg, 3, ""),
    childAccountIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    auditId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest}
 */
proto.dashboard.GetDashboardFilterValuesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardFilterValuesRequest;
  return proto.dashboard.GetDashboardFilterValuesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardFilterValuesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest}
 */
proto.dashboard.GetDashboardFilterValuesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (reader.readEnum());
      msg.setDashboardContext(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDimension(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addChildAccountIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardFilterValuesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardFilterValuesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardFilterValuesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardContext();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDimension();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChildAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional DASHBOARD_CONTEXT dashboard_context = 1;
 * @return {!proto.dashboard.DASHBOARD_CONTEXT}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.getDashboardContext = function() {
  return /** @type {!proto.dashboard.DASHBOARD_CONTEXT} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.dashboard.DASHBOARD_CONTEXT} value
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.setDashboardContext = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string dashboard_name = 2;
 * @return {string}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dimension = 3;
 * @return {string}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.getDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.setDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string child_account_ids = 4;
 * @return {!Array<string>}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.getChildAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.setChildAccountIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.addChildAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.clearChildAccountIdsList = function() {
  return this.setChildAccountIdsList([]);
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardFilterValuesRequest} returns this
 */
proto.dashboard.GetDashboardFilterValuesRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.GetDashboardFilterValuesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardFilterValuesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardFilterValuesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardFilterValuesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterValuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardFilterValuesResponse}
 */
proto.dashboard.GetDashboardFilterValuesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardFilterValuesResponse;
  return proto.dashboard.GetDashboardFilterValuesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardFilterValuesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardFilterValuesResponse}
 */
proto.dashboard.GetDashboardFilterValuesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFilterValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardFilterValuesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardFilterValuesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardFilterValuesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string filter_values = 1;
 * @return {!Array<string>}
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.getFilterValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.GetDashboardFilterValuesResponse} returns this
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.setFilterValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.GetDashboardFilterValuesResponse} returns this
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.addFilterValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.GetDashboardFilterValuesResponse} returns this
 */
proto.dashboard.GetDashboardFilterValuesResponse.prototype.clearFilterValuesList = function() {
  return this.setFilterValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.ReportingChildAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.ReportingChildAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.ReportingChildAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ReportingChildAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    region: jspb.Message.getFieldWithDefault(msg, 3, ""),
    suspendedAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.ReportingChildAccount}
 */
proto.dashboard.ReportingChildAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.ReportingChildAccount;
  return proto.dashboard.ReportingChildAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.ReportingChildAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.ReportingChildAccount}
 */
proto.dashboard.ReportingChildAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuspendedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.ReportingChildAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.ReportingChildAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.ReportingChildAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ReportingChildAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSuspendedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.dashboard.ReportingChildAccount.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.ReportingChildAccount} returns this
 */
proto.dashboard.ReportingChildAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string org_name = 2;
 * @return {string}
 */
proto.dashboard.ReportingChildAccount.prototype.getOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.ReportingChildAccount} returns this
 */
proto.dashboard.ReportingChildAccount.prototype.setOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string region = 3;
 * @return {string}
 */
proto.dashboard.ReportingChildAccount.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.ReportingChildAccount} returns this
 */
proto.dashboard.ReportingChildAccount.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 suspended_at = 4;
 * @return {number}
 */
proto.dashboard.ReportingChildAccount.prototype.getSuspendedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.ReportingChildAccount} returns this
 */
proto.dashboard.ReportingChildAccount.prototype.setSuspendedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.GetReportingChildAccountsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetReportingChildAccountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetReportingChildAccountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetReportingChildAccountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetReportingChildAccountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.dashboard.ReportingChildAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetReportingChildAccountsResponse}
 */
proto.dashboard.GetReportingChildAccountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetReportingChildAccountsResponse;
  return proto.dashboard.GetReportingChildAccountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetReportingChildAccountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetReportingChildAccountsResponse}
 */
proto.dashboard.GetReportingChildAccountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.ReportingChildAccount;
      reader.readMessage(value,proto.dashboard.ReportingChildAccount.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetReportingChildAccountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetReportingChildAccountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetReportingChildAccountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetReportingChildAccountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.dashboard.ReportingChildAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ReportingChildAccount children = 1;
 * @return {!Array<!proto.dashboard.ReportingChildAccount>}
 */
proto.dashboard.GetReportingChildAccountsResponse.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.dashboard.ReportingChildAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.ReportingChildAccount, 1));
};


/**
 * @param {!Array<!proto.dashboard.ReportingChildAccount>} value
 * @return {!proto.dashboard.GetReportingChildAccountsResponse} returns this
*/
proto.dashboard.GetReportingChildAccountsResponse.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dashboard.ReportingChildAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.ReportingChildAccount}
 */
proto.dashboard.GetReportingChildAccountsResponse.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dashboard.ReportingChildAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.GetReportingChildAccountsResponse} returns this
 */
proto.dashboard.GetReportingChildAccountsResponse.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.LiveChartCounts.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.LiveChartCounts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.LiveChartCounts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.LiveChartCounts.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    breakdownMap: (f = msg.getBreakdownMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.LiveChartCounts}
 */
proto.dashboard.LiveChartCounts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.LiveChartCounts;
  return proto.dashboard.LiveChartCounts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.LiveChartCounts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.LiveChartCounts}
 */
proto.dashboard.LiveChartCounts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 2:
      var value = msg.getBreakdownMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.LiveChartCounts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.LiveChartCounts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.LiveChartCounts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.LiveChartCounts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getBreakdownMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * optional int64 total = 1;
 * @return {number}
 */
proto.dashboard.LiveChartCounts.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.LiveChartCounts} returns this
 */
proto.dashboard.LiveChartCounts.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * map<string, int64> breakdown = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.dashboard.LiveChartCounts.prototype.getBreakdownMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.dashboard.LiveChartCounts} returns this
 */
proto.dashboard.LiveChartCounts.prototype.clearBreakdownMap = function() {
  this.getBreakdownMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.GetDashboardLiveCountsRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardLiveCountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardLiveCountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLiveCountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chartNamesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest}
 */
proto.dashboard.GetDashboardLiveCountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardLiveCountsRequest;
  return proto.dashboard.GetDashboardLiveCountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardLiveCountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest}
 */
proto.dashboard.GetDashboardLiveCountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    case 2:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addChartNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardLiveCountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardLiveCountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLiveCountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChartNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string dashboard_name = 1;
 * @return {string}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Filters filters = 2;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 2));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
*/
proto.dashboard.GetDashboardLiveCountsRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string audit_id = 3;
 * @return {string}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string chart_names = 4;
 * @return {!Array<string>}
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.getChartNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.setChartNamesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.addChartNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.GetDashboardLiveCountsRequest} returns this
 */
proto.dashboard.GetDashboardLiveCountsRequest.prototype.clearChartNamesList = function() {
  return this.setChartNamesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardLiveCountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardLiveCountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardLiveCountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLiveCountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    countsMap: (f = msg.getCountsMap()) ? f.toObject(includeInstance, proto.dashboard.LiveChartCounts.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardLiveCountsResponse}
 */
proto.dashboard.GetDashboardLiveCountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardLiveCountsResponse;
  return proto.dashboard.GetDashboardLiveCountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardLiveCountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardLiveCountsResponse}
 */
proto.dashboard.GetDashboardLiveCountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getCountsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.dashboard.LiveChartCounts.deserializeBinaryFromReader, "", new proto.dashboard.LiveChartCounts());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardLiveCountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardLiveCountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardLiveCountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLiveCountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.dashboard.LiveChartCounts.serializeBinaryToWriter);
  }
};


/**
 * map<string, LiveChartCounts> counts = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.dashboard.LiveChartCounts>}
 */
proto.dashboard.GetDashboardLiveCountsResponse.prototype.getCountsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.dashboard.LiveChartCounts>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.dashboard.LiveChartCounts));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.dashboard.GetDashboardLiveCountsResponse} returns this
 */
proto.dashboard.GetDashboardLiveCountsResponse.prototype.clearCountsMap = function() {
  this.getCountsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetVendorHealthVendorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetVendorHealthVendorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetVendorHealthVendorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetVendorHealthVendorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetVendorHealthVendorsRequest}
 */
proto.dashboard.GetVendorHealthVendorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetVendorHealthVendorsRequest;
  return proto.dashboard.GetVendorHealthVendorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetVendorHealthVendorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetVendorHealthVendorsRequest}
 */
proto.dashboard.GetVendorHealthVendorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetVendorHealthVendorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetVendorHealthVendorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetVendorHealthVendorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetVendorHealthVendorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filters filters = 1;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetVendorHealthVendorsRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 1));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetVendorHealthVendorsRequest} returns this
*/
proto.dashboard.GetVendorHealthVendorsRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetVendorHealthVendorsRequest} returns this
 */
proto.dashboard.GetVendorHealthVendorsRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetVendorHealthVendorsRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.VendorHealthVendor.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.VendorHealthVendor.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.VendorHealthVendor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.VendorHealthVendor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.VendorHealthVendor.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    riskTier: jspb.Message.getFieldWithDefault(msg, 3, ""),
    evaluationConfidence: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    evaluationStatus: jspb.Message.getFieldWithDefault(msg, 6, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 8, ""),
    ownerActive: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    assigneeEmailsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    lastReviewedAt: (f = msg.getLastReviewedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.VendorHealthVendor}
 */
proto.dashboard.VendorHealthVendor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.VendorHealthVendor;
  return proto.dashboard.VendorHealthVendor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.VendorHealthVendor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.VendorHealthVendor}
 */
proto.dashboard.VendorHealthVendor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskTier(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluationConfidence(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluationStatus(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnerActive(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeEmails(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastReviewedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.VendorHealthVendor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.VendorHealthVendor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.VendorHealthVendor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.VendorHealthVendor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRiskTier();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEvaluationConfidence();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEvaluationStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOwnerActive();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAssigneeEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getLastReviewedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string risk_tier = 3;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getRiskTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setRiskTier = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string evaluation_confidence = 4;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getEvaluationConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setEvaluationConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string evaluation_status = 6;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getEvaluationStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setEvaluationStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool active = 7;
 * @return {boolean}
 */
proto.dashboard.VendorHealthVendor.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string owner_email = 8;
 * @return {string}
 */
proto.dashboard.VendorHealthVendor.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool owner_active = 9;
 * @return {boolean}
 */
proto.dashboard.VendorHealthVendor.prototype.getOwnerActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setOwnerActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * repeated string assignee_emails = 10;
 * @return {!Array<string>}
 */
proto.dashboard.VendorHealthVendor.prototype.getAssigneeEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.setAssigneeEmailsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.addAssigneeEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.clearAssigneeEmailsList = function() {
  return this.setAssigneeEmailsList([]);
};


/**
 * optional google.protobuf.Timestamp last_reviewed_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.VendorHealthVendor.prototype.getLastReviewedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.VendorHealthVendor} returns this
*/
proto.dashboard.VendorHealthVendor.prototype.setLastReviewedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.VendorHealthVendor} returns this
 */
proto.dashboard.VendorHealthVendor.prototype.clearLastReviewedAt = function() {
  return this.setLastReviewedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.VendorHealthVendor.prototype.hasLastReviewedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.GetVendorHealthVendorsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetVendorHealthVendorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetVendorHealthVendorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetVendorHealthVendorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetVendorHealthVendorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorsList: jspb.Message.toObjectList(msg.getVendorsList(),
    proto.dashboard.VendorHealthVendor.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetVendorHealthVendorsResponse}
 */
proto.dashboard.GetVendorHealthVendorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetVendorHealthVendorsResponse;
  return proto.dashboard.GetVendorHealthVendorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetVendorHealthVendorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetVendorHealthVendorsResponse}
 */
proto.dashboard.GetVendorHealthVendorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.VendorHealthVendor;
      reader.readMessage(value,proto.dashboard.VendorHealthVendor.deserializeBinaryFromReader);
      msg.addVendors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetVendorHealthVendorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetVendorHealthVendorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetVendorHealthVendorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetVendorHealthVendorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.dashboard.VendorHealthVendor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VendorHealthVendor vendors = 1;
 * @return {!Array<!proto.dashboard.VendorHealthVendor>}
 */
proto.dashboard.GetVendorHealthVendorsResponse.prototype.getVendorsList = function() {
  return /** @type{!Array<!proto.dashboard.VendorHealthVendor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.VendorHealthVendor, 1));
};


/**
 * @param {!Array<!proto.dashboard.VendorHealthVendor>} value
 * @return {!proto.dashboard.GetVendorHealthVendorsResponse} returns this
*/
proto.dashboard.GetVendorHealthVendorsResponse.prototype.setVendorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dashboard.VendorHealthVendor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.VendorHealthVendor}
 */
proto.dashboard.GetVendorHealthVendorsResponse.prototype.addVendors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dashboard.VendorHealthVendor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.GetVendorHealthVendorsResponse} returns this
 */
proto.dashboard.GetVendorHealthVendorsResponse.prototype.clearVendorsList = function() {
  return this.setVendorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.SaveDashboardLayoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.SaveDashboardLayoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.SaveDashboardLayoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    layoutJson: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.SaveDashboardLayoutRequest}
 */
proto.dashboard.SaveDashboardLayoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.SaveDashboardLayoutRequest;
  return proto.dashboard.SaveDashboardLayoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.SaveDashboardLayoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.SaveDashboardLayoutRequest}
 */
proto.dashboard.SaveDashboardLayoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLayoutJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.SaveDashboardLayoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.SaveDashboardLayoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.SaveDashboardLayoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLayoutJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string dashboard_name = 1;
 * @return {string}
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.SaveDashboardLayoutRequest} returns this
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string layout_json = 2;
 * @return {string}
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.getLayoutJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.SaveDashboardLayoutRequest} returns this
 */
proto.dashboard.SaveDashboardLayoutRequest.prototype.setLayoutJson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardLayoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardLayoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardLayoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLayoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardLayoutRequest}
 */
proto.dashboard.GetDashboardLayoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardLayoutRequest;
  return proto.dashboard.GetDashboardLayoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardLayoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardLayoutRequest}
 */
proto.dashboard.GetDashboardLayoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardLayoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardLayoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardLayoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLayoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string dashboard_name = 1;
 * @return {string}
 */
proto.dashboard.GetDashboardLayoutRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardLayoutRequest} returns this
 */
proto.dashboard.GetDashboardLayoutRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardLayoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardLayoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardLayoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLayoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    layoutJson: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardLayoutResponse}
 */
proto.dashboard.GetDashboardLayoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardLayoutResponse;
  return proto.dashboard.GetDashboardLayoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardLayoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardLayoutResponse}
 */
proto.dashboard.GetDashboardLayoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLayoutJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardLayoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardLayoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardLayoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardLayoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLayoutJson();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string layout_json = 1;
 * @return {string}
 */
proto.dashboard.GetDashboardLayoutResponse.prototype.getLayoutJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardLayoutResponse} returns this
 */
proto.dashboard.GetDashboardLayoutResponse.prototype.setLayoutJson = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.dashboard.DASHBOARD_CONTEXT = {
  PRIMARY: 0,
  TRUST_PORTAL: 1
};

/**
 * @enum {number}
 */
proto.dashboard.DashboardPurpose = {
  ANY_SECTIONS: 0,
  CONTROL_LIST_SECTION: 1,
  DASHBOARD_SECTION: 2
};

/**
 * @enum {number}
 */
proto.dashboard.WidgetDataSource = {
  UNDEFINED_SOURCE: 0,
  DATA_AS_SOURCE: 1,
  RULE_AS_SOURCE: 2,
  DQL_AS_SOURCE: 3,
  RPC_AS_SOURCE: 4,
  HYBRID_AS_SOURCE: 5
};

/**
 * @enum {number}
 */
proto.dashboard.WidgetType = {
  CHART_WIDGET: 0,
  TABLE_WIDGET: 1,
  TEXT_WIDGET: 2
};

goog.object.extend(exports, proto.dashboard);
